import axios from "axios";

export default {
    namespaced: true,

    state: {
        inspectionProjectData: [],
    },

    mutations: {
        setProjectUsageData(state, data) {
            state.inspectionProjectData = data;
        }
    },

    actions: {
        getCustomerUsageData(context, { projectId, inspectionId }) {
            return new Promise((resolve, reject) => {
                axios.get('/api/projects/' + projectId + '/inspections/' + inspectionId + '/customer_usage_data').then(response => {
                    context.commit('setProjectUsageData', response.data);
                    resolve(response.data);
                }).catch(error => {
                    window.notify.apiError(error);
                    reject(error);
                });
            });
        }
    }

}
